<template>
    <div class="create-main-info">
        <div class="header">
            <div class="title">
                <span class="main">Добавление продукта. </span>
                <span class="sub">Общая информация</span>
            </div>
        </div>

        <MainInfo v-model="state"
                  class="middle"
        />

        <div class="footer">
            <div class="left"></div>
            <div class="right">
                <input class="ghost"
                       type="button"
                       value="Отмена"
                       @click="$emit('close')"
                />
                <input :disabled="v.$invalid"
                       class="primary"
                       type="button"
                       value="Далее"
                       @click="onNext()"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';

import MainInfo from './MainInfo.vue';

export default {
    props: {
        value: {
            type: Object,
            required: true,
        },
    },
    components: {
        MainInfo,
    },
    setup() {
        return {
            v: useVuelidate(),
        };
    },
    data() {
        return {
            state: {},
        };
    },
    methods: {
        onNext() {
            this.$emit('next', this.state);
        },
    },
    created() {
        Object.assign(this.state, this.value);
    },
    watch: {
        state() {
            this.$emit('changed');
        },
        value: {
            immediate: true,
            handler(value) {
                Object.assign(this.state, value);
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.create-main-info {
    .middle {
        padding-bottom: 40px;
    }
}
</style>
